<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<circle id="liveInactiveOuterCircle" cx="12" cy="12" r="4" fill="#E61F3C"/>
	<circle id="liveInactiveInnerCircle" opacity="0.25" cx="12" cy="12" r="10" fill="#E61F3C"/>
	</svg>
	